/**
 *
 *  Author：tanyaohua 2020-08-20
 *  discription: 图片弹框选择器
 *
 *  @param   {[type]}  options  [isMultiple 是否多选，true-多选；false-单选]
 *  @param   {[type]}  params [传的参数]
 *  @param   {[type]}  requestUrl [传的参数]请求的地址
 *  options:{
 *   windowTitle:左上角的名称
 *   isMultiple：默认false，单选。 true多选
 *   itemDatas：需要传入的对象
 *   }
 */
'use strict';
angular.module('pictureSelectorModule', []).controller('pictureSelectorCtrl', [
    '$scope',
    '$modalInstance',
    'options',
    'params',
    'trsHttpService',
    'globleParamsSet',
    '$sessionStorage',
    function (
        $scope,
        $modalInstance,
        options,
        params,
        trsHttpService,
        globleParamsSet,
        $sessionStorage
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.windowTitle = options.windowTitle || '系统封面';
            $scope.status = {
                isMultiple: options.isMultiple || false,
            };
            $scope.items = options.itemDatas || [];
            $scope.params = params || {};
            $scope.data = {
                selectedArray: [],
                lists: {},
            };
            $scope.page = {
                ITEMCOUNT: 0,
                CURRPAGE: 1,
                PAGESIZE: 8,
                PAGECOUNT: 1,
            };
        }

        /**
         * [initData 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData description]获得显示的数据
         * @return {[type]} [description]
         */
        function requestData() {
            // 当没有传来数组对象的时候 会发请求
            if (options.itemDatas && options.itemDatas.length > 0) {
                $scope.items = paginationOwn($scope.page.PAGESIZE, $scope.page.CURRPAGE, options.itemDatas);
            } else {
                // 第四个传的是toke
                trsHttpService.httpServer('/bigdata/tv/transfer/video/detail', $scope.params, 'get', false, {'token': $scope.params.userId}).then(function (data) {
                    $scope.data.lists = data.datas.pics;
                    $scope.items = paginationOwn($scope.page.PAGESIZE, $scope.page.CURRPAGE, $scope.data.lists);
                });
            }
        }

        /**
         * [changeCheck description]单选
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.changeCheck = function (item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                if ($scope.status.isMultiple) {
                    // 多选直接push
                    $scope.data.selectedArray.push(item);
                } else {
                    // 单选先清空
                    $scope.data.selectedArray = [];
                    $scope.data.selectedArray.push(item);
                }
                
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            // 不支持分页 分页即清空
            $scope.data.selectedArray = [];
            requestData();
        };

        /**
         * [paginationOwn description]如果传入的自己的数组 需要一个自己的分页效果
         *
         * @param   {[type]}  pageSize     [pageSize description]
         * @param   {[type]}  currentPage  [currentPage description]
         * @param   {[type]}  arr          [arr description]
         *
         * @return  {[type]}               [return description]
         */
        function paginationOwn(pageSize, currentPage, arr) {
            var skipNum = (currentPage - 1) * pageSize;
            var newArr = (skipNum + pageSize >= arr.length) ? arr.slice(skipNum, arr.length) : arr.slice(skipNum, skipNum + pageSize);
            $scope.page.ITEMCOUNT = arr.length;
            $scope.page.PAGECOUNT = Math.ceil(arr.length / $scope.page.PAGESIZE);
            return newArr;
        }

        /**
         * [confirm] 确认
         * @return {[type]} [description]
         */
        $scope.confirm = function () {
            $modalInstance.close(
                $scope.data.selectedArray
            );
        
        };

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function () {
            $modalInstance.dismiss();
        };

    },
]);
